import {
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography
} from '@mui/material';
import React, { useCallback, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import RetryIcon from '@mui/icons-material/Replay';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  billPaymentAction,
  SEND_PAYMENT_TO_REBILL
} from 'src/store/actions/paymentsActions';
import ConfirmationDialog from 'src/components/ConfirmDialog/ConfirmationDialog';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';

const PaymentsFailureRowMenu = ({ id }) => {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const isLoading = useSelector(
    isLoadingSelector([SEND_PAYMENT_TO_REBILL.action])
  );

  const handleOpenMenu = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleRetry = useCallback(() => {
    dispatch(billPaymentAction(id));
  }, [id]);

  const handleOpenConfirmationDialog = () => {
    setOpenConfirmationDialog(true);
    handleCloseMenu();
  };

  const handleCloseConfirmationDialog = () => {
    setOpenConfirmationDialog(false);
  };

  return (
    <Box component="div">
      <IconButton
        aria-label="documentsMenu"
        id="documentsMenu"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        onClick={handleOpenMenu}
      >
        <MoreVertIcon />
      </IconButton>

      <Menu
        id={id}
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        PaperProps={{
          sx: {
            width: '27ch',
            bgcolor: 'background.paper',
            color: 'text.primary',
            boxShadow: 1
          }
        }}
      >
        <MenuItem onClick={handleOpenConfirmationDialog}>
          <ListItemIcon>
            <RetryIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">
            {t('TRANSACTION.SEND_TO_REBILL')}
          </Typography>
        </MenuItem>
      </Menu>
      <ConfirmationDialog
        open={openConfirmationDialog}
        handleClose={handleCloseConfirmationDialog}
        onSubmit={handleRetry}
        isLoading={isLoading}
        title={t(
          'ENUMS.AUTOMATIC_DEBIT_COLLECTION_ACTIONS.REACTIVATE_CHARGE_TITLE'
        )}
        description={t(
          'ENUMS.AUTOMATIC_DEBIT_COLLECTION_ACTIONS.REACTIVATE_CHARGE_DESCRIPTION'
        )}
      />
    </Box>
  );
};

PaymentsFailureRowMenu.propTypes = {
  id: PropTypes.string.isRequired
};

export default PaymentsFailureRowMenu;
